import { inject, Pipe, type PipeTransform } from '@angular/core';
import type { EventItem, EventType } from '../../core/models/middleware/event-item.model';
import { DateFormattingService } from '../../core/services/date-formatting.service';

@Pipe({
  name: 'eventDate',
  standalone: true,
})
export class EventDatePipe implements PipeTransform {
  private dateFormattingService = inject(DateFormattingService);

  transform(event: EventItem<EventType>): string {
    const startDate = new Date(event.startDate);
    const endDate = event.endDate ? new Date(event.endDate) : null;

    return this.dateFormattingService.formatEventDateCompact(startDate, endDate || undefined);
  }
}
